// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__UsB5l","photoWrapper":"styles_photoWrapper__pUPr9","secondPlaceholder":"styles_secondPlaceholder__2AHfi"};